// assets/custom-header.js
// Interactivity for Amber Se header: mobile menu, Shop All dropdown, scroll effect, and keyboard support.

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.custom-header');
  if (!header) return;

  const toggleBtn = header.querySelector('.custom-header__toggle');
  const shopBtn = header.querySelector('#ShopAllBtn');
  const navMenu = header.querySelector('.custom-header__nav');

  /* Toggle mobile menu (hamburger) */
  if (toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      const isOpen = header.classList.toggle('open');
      toggleBtn.setAttribute('aria-expanded', isOpen);
    });
  }

  /* Toggle Shop All dropdown */
  if (shopBtn) {
    shopBtn.addEventListener('click', function (e) {
      // Only handle taps on mobile; desktop uses hover
      if (window.innerWidth <= 749) {
        e.preventDefault();
        const parentLi = shopBtn.parentElement;
        const isExpanded = shopBtn.getAttribute('aria-expanded') === 'true';
        shopBtn.setAttribute('aria-expanded', String(!isExpanded));
        parentLi.classList.toggle('open');
      }
    });
  }
  const subMenuBtn = document.querySelector('.custom-header__submenu-link');

if (subMenuBtn) {

    subMenuBtn.addEventListener('click', function(e){

        if(window.innerWidth <= 749){

            e.preventDefault();

            this.parentElement.classList.toggle('open');

        }

    });

}
document.querySelectorAll('.custom-header__submenu-link').forEach(function(link){

    link.addEventListener('click', function(e){

        if(window.innerWidth <= 749){

            e.preventDefault();

            this.parentElement.classList.toggle('open');

        }

    });

});

  /* Close menus when clicking outside */
  document.addEventListener('click', function (e) {
    if (!header.contains(e.target)) {
      // Close mobile menu and dropdown
      header.classList.remove('open');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      if (shopBtn) {
        shopBtn.setAttribute('aria-expanded', 'false');
        shopBtn.parentElement.classList.remove('open');
      }
    }
  });

  /* Close menus on Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      header.classList.remove('open');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      if (shopBtn) {
        shopBtn.setAttribute('aria-expanded', 'false');
        shopBtn.parentElement.classList.remove('open');
        shopBtn.focus();  // Return focus to the Shop All button per WCAG practice
      }
    }
  });

  /* Header scroll effect */
  function updateHeaderOnScroll() {
    if (window.scrollY > 30) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }
  updateHeaderOnScroll();
  window.addEventListener('scroll', updateHeaderOnScroll);
});